import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as ClassicEditor from 'src/assets/js/ckeditor';

@Component({
    selector: 'wfdss-rte-form-control',
    templateUrl: './rte-form-control.component.html',
    styleUrls: ['./rte-form-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: RTEFormControlComponent,
        },
    ],
    standalone: false
})
/**
 * @description CKE5 Based RTE, compatible with reactive & template driven ng formcontrol
 * @reference this post for an explanation of how the ControlValueAccessor works: https://blog.angular-university.io/angular-custom-form-controls/
 */
export class RTEFormControlComponent implements OnInit, AfterViewInit, OnDestroy, ControlValueAccessor {
  @ViewChild("editorPlaceholder", {static: true}) editorPlaceholder: ElementRef
  public editor : ClassicEditor
  /** @description Stores initial(parent FormControl) data until editor is created.  */
  public initializationEditorData
  // ====BEGIN CVA Properties====
  onChange = (editorData) => {}   // Placeholder function to prevent null errors 
  onTouched = () => {} // Placeholder function to prevent null errors
  touched = false;
  disabled = false;
  // ====END CVA Properties====
  constructor() {}
  //===== BEGIN ControlValueAcessor Interface methods
  writeValue(newData: string): void {
    if(this.editor){
      this.editor.setData(newData)
      return
    } 
    this.initializationEditorData = newData // On first load, editor has not yet initialized. This saves init data to pass to Editor.create()
  }  
  registerOnChange(onChange: ()=>{}): void { //runs on init
    this.onChange = onChange
  }
  registerOnTouched(onTouched: ()=>{}): void { //runs on init
    this.onTouched = onTouched
    console.warn("register on touched")
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
    if(!this.editor){
      return
    }
    if(this.disabled){
      this.editor.enableReadOnlyMode("abc")
    } else {
      this.editor.disableReadOnlyMode("abc")
    }
  }
    //===== END ControlValueAcessor Interface methods
  integrateEditorIntoControlValueAccessorInterface(){
    this.editor.model.document.on( 'change:data', (event) => {
      this.onChange(this.editor.getData())
      this.markAsTouched()
    })
  }  
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    ClassicEditor
    .create( this.editorPlaceholder.nativeElement as HTMLElement )
    .then( editor => {
        this.editor = editor
        if(this.initializationEditorData) {this.editor.setData(this.initializationEditorData)}
        this.integrateEditorIntoControlValueAccessorInterface()
        console.log( 'CKE5 Editor initialized successfully', editor );
        this.setDisabledState(this.disabled)// Editor must be created to disable it.
    } )
    .catch( err => {
        console.error( "CKE5 Error: Editor instance failed to initialize", err );
    } );
  }
  ngOnDestroy(): void {
    this.editor.destroy()
  }
}
